import { alpha, type Theme } from '@mui/material';

export const HF_CHIP_TONES = ['pending', 'working', 'complete', 'neutral', 'pass', 'warn', 'block', 'off'] as const;

export type HFChipTone = (typeof HF_CHIP_TONES)[number];

const TONE_PALETTE = {
  working: 'primary',
  pending: 'warning',
  warn: 'warning',
  complete: 'success',
  pass: 'success',
  block: 'error',
} as const;

/** Board tones: pending and warn share amber; complete and pass share green. */
export function chipToneColors(tone: HFChipTone, theme: Theme): { bgcolor: string; color: string; border: string } {
  const isDark = theme.palette.mode === 'dark';
  if (tone === 'neutral') {
    return {
      bgcolor: alpha(theme.palette.text.secondary, isDark ? 0.16 : 0.1),
      color: theme.palette.text.secondary,
      border: 'none',
    };
  }
  if (tone === 'off') {
    return { bgcolor: 'transparent', color: theme.palette.text.disabled, border: `1px solid ${theme.palette.divider}` };
  }
  const palette = theme.palette[TONE_PALETTE[tone]];
  return {
    bgcolor: alpha(palette.main, isDark ? 0.2 : 0.14),
    color: isDark ? palette.light : palette.dark,
    border: 'none',
  };
}
